export default "assets/images/icons/cross-5aa08168.svg";